import { FILTER_MENU } from '../actionTypes';

const filterMenu = (search = '') => ({ type: FILTER_MENU, payload: search });

export default filterMenu;
